import { useState } from "react";
import { CModal, CModalBody, CModalHeader, CModalTitle } from "@coreui/react";
import TaxPayer from "../../models/tax-payer";
import TaxPayerSuspensionForm from "./TaxPayerSuspensionForm";

interface Props {
  show: boolean;
  taxPayer?: TaxPayer;
  onCancel: () => void;
  onSuccess: (suspended: boolean) => void;
}

const TaxPayerSuspensionModal = ({
  show,
  taxPayer,
  onCancel,
  onSuccess,
}: Props) => {
  const [saving, setSaving] = useState(false);

  return (
    <CModal
      show={show}
      size="lg"
      onClose={() => {
        if (!saving) onCancel();
      }}
    >
      <CModalHeader closeButton={!saving}>
        <CModalTitle>
          Suspensión: {taxPayer?.socialName || taxPayer?.ruc}
        </CModalTitle>
      </CModalHeader>
      <CModalBody>
        {show && taxPayer && (
          <TaxPayerSuspensionForm
            key={taxPayer.id}
            taxPayer={taxPayer}
            onCancel={onCancel}
            onSuccess={onSuccess}
            onBusyChange={setSaving}
          />
        )}
      </CModalBody>
    </CModal>
  );
};

export default TaxPayerSuspensionModal;
